import { HubConnectionBuilder } from "@aspnet/signalr";

// HubConnection state values for @aspnet/signalr: 0 = Disconnected, 1 = Connected
const HUB_DISCONNECTED = 0;

class PmsHub {
  constructor() {
    this.client = new HubConnectionBuilder().withUrl("/api/pms-hub").build();
    //this.clientSystemNotification = new HubConnectionBuilder().withUrl("/api/system-notification-hub").build();
    //this.clientShift = new HubConnectionBuilder().withUrl("/api/shift-hub").build();
    //this.clientUserAccessHub = new HubConnectionBuilder().withUrl("/api/user-access-hub").build();
  }

  async start(groupName, oldGroupName) {
    if (this.client.state !== HUB_DISCONNECTED) return;
    try {
      await this.client.start();
      await this.client.invoke("JoinGroupRoom", `${groupName}deallocate`, `${oldGroupName}deallocate`);
     // await this.client.invoke("JoinGroupRoom", `${groupName}bookingCancelled`, `${oldGroupName}bookingCancelled`);
      await this.client.invoke("JoinGroupRoom", `${groupName}messages`, `${oldGroupName}messages`);
    } catch (e) {
      //console.log('PMSHUB start error:', e);
      setTimeout(() => this.start(groupName, oldGroupName), 5000);
    }
  }

  //async startSystemNotification(propertyId, oldPropertyId) {
  //  if (this.clientSystemNotification.state !== HUB_DISCONNECTED) return;
  //  try {
  //    await this.clientSystemNotification.start();
  //    await this.clientSystemNotification.invoke("JoinGroupRoom", `Property_${propertyId}_Notifications`, `Property_${oldPropertyId}_Notifications`);
  //  } catch (e) {
  //   // console.log('PMSHUB startSystemNotification error:', e);
  //    setTimeout(() => this.startSystemNotification(propertyId, oldPropertyId), 5000);
  //  }
  //}

  //async loginJoinAccount() {
  //  if (this.clientUserAccessHub.state !== HUB_DISCONNECTED) return;
  //  try {
  //    console.log('Login & Join User Group');
  //    await this.clientUserAccessHub.start();
  //    await this.clientUserAccessHub.invoke("JoinUserAccessRoom");
  //  } catch (e) {
  //   // console.log('PMSHUB loginJoinAccount error:', e);
  //    setTimeout(() => this.loginJoinAccount(), 5000);
  //  }
  //}

  //async startShift(propertyId, oldPropertyId) {
  //  if (this.clientShift.state !== HUB_DISCONNECTED) return;
  //  try {
  //    await this.clientShift.start();
  //    await this.clientShift.invoke("JoinGroupRoom", `Property_${propertyId}_Shift`, `Property_${oldPropertyId}_Shift`);
  //  } catch (e) {
  //   // console.log('PMSHUB startShift error:', e);
  //    setTimeout(() => this.startShift(propertyId, oldPropertyId), 5000);
  //  }
  //}

  stopAll() {
    this.client.stop();
    //this.clientSystemNotification.stop();
    //this.clientShift.stop();
    //this.clientUserAccessHub.stop();
  }
}


export default new PmsHub();



// WEBPACK FOOTER //
// ./src/store/modules/pms-hub.js